module.exports = __webpack_public_path__ + "static/media/twitter-icon.38112b13.svg";